import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import n from "./index289.js";
const l = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(c, o, p, f, i, m) {
  return e(), t("svg", s, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M8.421 19.397a.818.818 0 0 1-.079-1.066l.08-.091 5.966-5.967-5.967-5.967a.818.818 0 0 1-.079-1.066l.08-.091a.818.818 0 0 1 1.065-.08l.092.08 6.545 6.545c.29.29.317.745.08 1.066l-.08.091-6.545 6.546a.818.818 0 0 1-1.158 0Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ n(l, [["render", a]]);
export {
  u as default
};
